export default "__VITE_ASSET__Cm_Vzx_D__"